// /Redux/Slices/user-slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserSessionModel, ChallengeModel } from '@/Domains';

interface SessionState {
    userSession: UserSessionModel | null;
    userChallenge: ChallengeModel | null;
}

const initialState: SessionState = {
    userSession: null,
    userChallenge: null,
};

const sessionStateSlice = createSlice({
    name: 'sessionState',
    initialState,
    reducers: {
        setUserSession(state, action: PayloadAction<UserSessionModel | null>) {
            state.userSession = action.payload;
        },
        setUserChallenge(state, action: PayloadAction<ChallengeModel | null>) {
            state.userChallenge = action.payload;
        },
        resetUserSession(state) {
            state.userSession = null;
        },
    },
});

export const { actions: sessionStateActions, reducer: sessionStateReducer } = sessionStateSlice;
